/* ============================================================================
   MUIZZ EDITORIAL — paylasilan davranislar

   1. Reveal      : [data-mz-reveal] alttan clip-path ile acilir, kademeli
   2. Parallax    : [data-mz-parallax] kapsayicisi icinde yavas kayar
   3. Ray         : [data-mz-rail] + [data-mz-prev]/[data-mz-next] okları

   Bolume ozgu davranislar (hero gecisi, acilan kartlar, koku ailesi) ilgili
   section dosyasinin icinde durur — bu dosya sadece tekrar edenleri toplar.
   ========================================================================= */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* -------------------------------------------------------------------------
     1. Reveal
     ---------------------------------------------------------------------- */

  function initReveal(root) {
    var items = root.querySelectorAll('[data-mz-reveal]:not([data-mz-observed])');
    if (!items.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.setAttribute('data-mz-observed', '');
        el.classList.add('is-revealed');
      });
      return;
    }

    // Sayfa gercek kaydirmayi .page-wrapper icinde yapiyor (body overflow:hidden).
    // Kok olarak onu vermezsek gozlemci guvenilir tetiklenmiyor ve bolumler
    // yalnizca emniyet agi suresi dolunca gorunuyordu.
    var scrollRoot = document.querySelector('.page-wrapper');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { root: scrollRoot || null, rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );

    // Ilk boyamada ekranda (veya hemen altinda) olan her sey beklemeden acilsin
    var vh = window.innerHeight || 800;
    items.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh + 300) el.classList.add('is-revealed');
    });

    // Ayni kapsayicidaki kardesler sirayla acilsin
    var groups = new Map();

    items.forEach(function (el) {
      el.setAttribute('data-mz-observed', '');
      var parent = el.parentElement || root;
      var index = groups.get(parent) || 0;
      groups.set(parent, index + 1);
      if (!el.style.getPropertyValue('--mz-delay')) {
        el.style.setProperty('--mz-delay', Math.min(index, 6) * 70 + 'ms');
      }
      observer.observe(el);
    });

    // Emniyet agi: gozlemci herhangi bir sebeple tetiklenmezse icerik sonsuza
    // kadar gizli kalmasin. Sure kisa tutuluyor — uzun tutuldugunda hizli
    // kaydiran kullanici bos bolumler goruyordu.
    setTimeout(function () {
      items.forEach(function (el) {
        if (!el.classList.contains('is-revealed')) {
          el.classList.add('is-revealed');
          observer.unobserve(el);
        }
      });
    }, 1200);
  }

  /* -------------------------------------------------------------------------
     2. Parallax
     ---------------------------------------------------------------------- */

  function initParallax(root) {
    if (reduceMotion.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-mz-parallax]:not([data-mz-parallax-on])'));
    if (!layers.length) return;

    layers.forEach(function (el) {
      el.setAttribute('data-mz-parallax-on', '');
    });

    if (!window.__mzParallaxLayers) {
      window.__mzParallaxLayers = [];

      var ticking = false;

      var update = function () {
        ticking = false;
        var viewport = window.innerHeight;

        window.__mzParallaxLayers.forEach(function (el) {
          if (!el.isConnected) return;
          var rect = el.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > viewport + 200) return;

          // -1 .. 1 arasi ilerleme
          var progress = (rect.top + rect.height / 2 - viewport / 2) / viewport;
          var amount = parseFloat(el.getAttribute('data-mz-parallax')) || 8;
          el.style.transform = 'translate3d(0,' + (-progress * amount).toFixed(2) + '%,0)';
        });
      };

      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    Array.prototype.push.apply(window.__mzParallaxLayers, layers);
  }

  /* -------------------------------------------------------------------------
     3. Ray
     ---------------------------------------------------------------------- */

  function initRails(root) {
    var rails = root.querySelectorAll('[data-mz-rail]:not([data-mz-rail-on])');

    rails.forEach(function (rail) {
      rail.setAttribute('data-mz-rail-on', '');

      var scope = rail.closest('[data-mz-scope]') || root;
      var prev = scope.querySelector('[data-mz-prev]');
      var next = scope.querySelector('[data-mz-next]');

      var step = function () {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      var sync = function () {
        if (!prev || !next) return;
        // 2px tolerans: alt piksel kaydirmalarda buton erken kilitlenmesin
        var maxScroll = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maxScroll;
      };

      if (prev) {
        prev.addEventListener('click', function () {
          rail.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          rail.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();

      initDrag(rail);
    });
  }

  /* Fare ile tutup surukleyerek kaydirma (masaustu).
     Surukleme sirasinda kartlarin baglantilari tetiklenmemeli. */
  function initDrag(rail) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    rail.classList.add('mz-rail--grab');

    rail.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      // Buton ve form ogelerinde surukleme baslatma
      if (e.target.closest('button, input, select, textarea')) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = rail.scrollLeft;
      rail.classList.add('is-dragging');
    });

    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        moved = true;
        rail.setPointerCapture(e.pointerId);
      }
      if (moved) {
        e.preventDefault();
        rail.scrollLeft = startScroll - dx;
      }
    });

    function end(e) {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
      try {
        rail.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* yakalama yoktu */
      }
      // Surukleme bittiyse tiklamayi yut
      if (moved) {
        var swallow = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        rail.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(function () {
          rail.removeEventListener('click', swallow, { capture: true });
        }, 60);
      }
    }

    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('pointerleave', end);

    // Suruklerken metin secilmesin
    rail.addEventListener('dragstart', function (e) {
      if (moved) e.preventDefault();
    });
  }

  /* -------------------------------------------------------------------------
     4. Koleksiyon sutun secici (4 / 5 / 6)

     Butonlar Horizon'un filtre cubugunun icinde duruyor; secim <html> uzerinde
     data-mz-cols olarak tasinir ve localStorage'da hatirlanir.
     ---------------------------------------------------------------------- */

  var COLS_KEY = 'muizz:cols';

  function colsApply(cols) {
    document.documentElement.setAttribute('data-mz-cols', cols);
    document.querySelectorAll('[data-mz-cols-btn]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-mz-cols-btn') === cols));
    });
  }

  function colsStored() {
    try {
      return localStorage.getItem(COLS_KEY);
    } catch (e) {
      return null;
    }
  }

  function initCols(root) {
    var buttons = root.querySelectorAll('[data-mz-cols-btn]:not([data-mz-cols-on])');
    if (!buttons.length) return;

    buttons.forEach(function (b) {
      b.setAttribute('data-mz-cols-on', '');
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var cols = b.getAttribute('data-mz-cols-btn');
        colsApply(cols);
        try {
          localStorage.setItem(COLS_KEY, cols);
        } catch (err) {
          /* gizli mod */
        }
      });
    });

    colsApply(colsStored() || '5');
  }

  // Filtreleme sonrasi liste yeniden cizilirse secim korunsun
  document.addEventListener('shopify:section:load', function () {
    colsApply(colsStored() || '5');
  });

  /* -------------------------------------------------------------------------
     5. Isim yazdirma secenegi

     Evet secilince isim alani acilir. Olay delegasyonu kullaniliyor: hizli
     goruntuleme penceresi bu isaretlemeyi klonlayarak tasidigi icin bloga
     gomulu bir script orada calismazdi.
     ---------------------------------------------------------------------- */

  /* Blok, sepete ekle formunun DISINDA duruyor (Horizon formu buy-buttons
     blogunun icinde aciyor). FormData yalnizca formun kendi alanlarini
     topladigi icin secim siparise hic dusmezdi; alanlari 'form' niteligiyle
     forma bagliyoruz. */
  function namePropBindForm(root) {
    var scope =
      root.closest('.product-details') ||
      root.closest('.quick-add-modal__content') ||
      root.closest('product-information, .shopify-section') ||
      document;

    var form = scope.querySelector('form.shopify-product-form[id]');
    if (!form) form = document.querySelector('form.shopify-product-form[id]');
    if (!form) return;

    // DIKKAT: form.id KULLANILMAZ. Shopify formunda <input name="id"> var ve
    // formun adli oge erisimi bunu id ozelligine golgeliyor — form.id o inputu
    // donduruyor, kimligi degil.
    var formId = form.getAttribute('id');
    if (!formId) return;

    root.querySelectorAll('input[name^="properties"]').forEach(function (el) {
      if (el.getAttribute('form') !== formId) el.setAttribute('form', formId);
    });
  }

  function namePropApply(root) {
    var yes = root.querySelector('[data-mz-nameprop-yes]');
    var field = root.querySelector('[data-mz-nameprop-field]');
    var input = root.querySelector('[data-mz-nameprop-input]');
    if (!yes || !field || !input) return;

    namePropBindForm(root);

    var acik = yes.checked;
    field.hidden = !acik;
    input.disabled = !acik; // gizliyken forma hic gonderilmesin
    if (!acik) input.value = '';
  }

  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-mz-nameprop-yes], [data-mz-nameprop-no]');
    if (!radio) return;
    var root = radio.closest('[data-mz-nameprop]');
    if (!root) return;
    namePropApply(root);
    if (root.querySelector('[data-mz-nameprop-yes]').checked) {
      var input = root.querySelector('[data-mz-nameprop-input]');
      if (input) setTimeout(function () { input.focus(); }, 120);
    }
  });

  function initNameProp(root) {
    root.querySelectorAll('[data-mz-nameprop]').forEach(namePropApply);
  }

  /* Hizli goruntuleme penceresi icerigi sonradan DOM'a tasindigi icin
     baslatma orada calismiyordu; eklenen dugumleri izliyoruz. */
  if (window.MutationObserver) {
    new MutationObserver(function (kayitlar) {
      for (var i = 0; i < kayitlar.length; i++) {
        var eklenen = kayitlar[i].addedNodes;
        for (var j = 0; j < eklenen.length; j++) {
          var node = eklenen[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-mz-nameprop]')) {
            namePropApply(node);
          } else if (node.querySelector && node.querySelector('[data-mz-nameprop]')) {
            initNameProp(node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* -------------------------------------------------------------------------
     6. Puan ozetinden yorumlara kaydirma

     Gercek kaydirma kabi <body> degil .page-wrapper; bu yuzden tarayicinin
     kendi cirpi (anchor) davranisina guvenmiyoruz, hedefi elle kaydiriyoruz.
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mz-scroll]');
    if (!trigger) return;

    var id = (trigger.getAttribute('href') || '').replace('#', '');
    if (!id) return;

    var target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* -------------------------------------------------------------------------
     7. Sepet bildirimi (toast)

     Shopify'in standart 'cart:lines-update' olayini dinler. Sepet cekmecesi
     otomatik acilmadigi icin geri bildirimi bu ustlenir.
     ---------------------------------------------------------------------- */

  var toastEl = null;
  var toastTimer = null;

  function buildToast() {
    var el = document.createElement('div');
    el.className = 'mz-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="mz-toast__mark" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none"><path d="M4 12.5l5 5L20 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/></svg>' +
      '</span>' +
      '<span class="mz-toast__text"><strong class="mz-toast__title"></strong>' +
      '<span class="mz-toast__sub"></span></span>' +
      '<a class="mz-toast__link" href="/cart">Sepeti gör</a>' +
      '<span class="mz-toast__bar"></span>';
    document.body.appendChild(el);
    return el;
  }

  function showToast(title, sub) {
    if (!toastEl) toastEl = buildToast();

    toastEl.querySelector('.mz-toast__title').textContent = title || 'Sepete eklendi';
    toastEl.querySelector('.mz-toast__sub').textContent = sub || '';

    // animasyonu bastan sar
    toastEl.classList.remove('is-open');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-open');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-open');
    }, 4200);
  }

  function initToast() {
    // Shopify olayi 'shopify:' onekiyle ucuyor; onekli ve oneksiz ikisini de
    // dinliyoruz ki surum degisirse sessizce kirilmasin.
    ['shopify:cart:lines-update', 'cart:lines-update'].forEach(function (name) {
      document.addEventListener(name, onCartUpdate);
    });
  }

  var sonToast = 0;

  function onCartUpdate(event) {
    var action = event.action || (event.detail && event.detail.action);
    if (action && action !== 'add') return;

    // Ayni ekleme iki olay ucurursa tek bildirim goster
    var simdi = Date.now();
    if (simdi - sonToast < 600) return;
    sonToast = simdi;

    // Eklenen urunun adini yakalamaya calis (yoksa genel mesaj)
    var name = '';
    try {
      var src = event.target;
      var card =
        src && src.closest
          ? src.closest('.mz-card, .product-information, .quick-add-modal, .product-grid__item')
          : null;
      var titleEl = card && card.querySelector('.mz-card__title-link, .product-title, h1, h3');
      if (titleEl) name = titleEl.textContent.trim();
    } catch (e) {
      /* urun adi bulunamadi, genel mesajla devam */
    }

    showToast('Sepete eklendi', name);
  }

  /* -------------------------------------------------------------------------
     Baslatma
     ---------------------------------------------------------------------- */

  var toastReady = false;

  function init(root) {
    var scope = root || document;
    initReveal(scope);
    initParallax(scope);
    initRails(scope);
    initCols(scope);
    initNameProp(scope);
    if (!toastReady) {
      toastReady = true;
      initToast();
    }
  }

  window.MuizzInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Tema editorunde bolum yeniden yuklendiginde
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
